export default __webpack_public_path__ + "static/media/lifesatisfaction1help1.e7eb361f.png";